import React from 'react';

const Processing = React.createContext({ isProcessing: false, setIsProcessing: (isProcessing: boolean) => {}});
export const Consumer = Processing.Consumer;

export default Processing;